import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const { systemPowerSingleOrMultipleUsers } = loanFormModel.formField;

class IsSystemPowerSingleOrMultipleUsersEqualTo implements Rule {
  private systemPowerSingleOrMultipleUsersValue:
    | 'Single User'
    | 'Multiple Users';

  public setValue(
    NewSystemPowerSingleOrMultipleUsers: 'Single User' | 'Multiple Users'
  ) {
    this.systemPowerSingleOrMultipleUsersValue =
      NewSystemPowerSingleOrMultipleUsers;
    return this;
  }

  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const singleOrMultipleUsers = application[
      systemPowerSingleOrMultipleUsers.name
    ] as 'Single User' | 'Multiple Users' | null;
    return singleOrMultipleUsers === this.systemPowerSingleOrMultipleUsersValue;
  }
}

export default new IsSystemPowerSingleOrMultipleUsersEqualTo();
